import axios from "axios";
import API_BASE_URL from '../../config';

const SetCoursesUserServices = async (token, idUser, course_id) => {
  try {
    if (!token) {
      throw new Error("No token available");
    }

    const dataSend = {
      user_id: idUser,
      course_id: course_id
  }

    const responseSetCoursesUser = await axios.post(`${ API_BASE_URL }api/set-courses-user/`,
      dataSend, 
      {
        headers: {
            Authorization: `Bearer ${token}`,
        }
      }
    )
  
    console.log(responseSetCoursesUser.data)
    return responseSetCoursesUser.data;


    } catch (error) {
      console.error('Error en la solicitud:', error.response ? error.response.data : error.message);
      throw error;
    }
};

export default SetCoursesUserServices;